<template>
    <b-container>
        <b-row>
            <b-col>
                <b-row>
                    <b-col>
                        <app-form-text-input
                            v-model="message.name"
                            label="Asunto"
                            @input="$v.message.name.$touch()"
                            :has-error="$v.message.name.$error"
                            error-message="Debe diligenciar el campo"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <app-form-textarea-input
                            v-model="message.description"
                            label="Mensaje"
                            @input="$v.message.description.$touch()"
                            :has-error="$v.message.description.$error"
                            error-message="Debe diligenciar el campo"
                        />
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-list-group>
                    <b-list-group-item
                        v-for="client in orderedClients"
                        :key="client.id"
                    >
                        <b-checkbox
                            v-model="selectedClients"
                            :value="client.id"
                        ></b-checkbox>
                        {{ client.name }}
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="d-flex justify-content-end mt-3">
                <b-btn
                    variant="confirm"
                    :disabled="inProgress"
                    @click="sendMessage"
                    >Enviar Mensaje</b-btn
                >
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import broadcastMessagesRepository from "../../../../repositories/broadcastMessages.repository";
export default {
    name: "company_broadcas_message_form",
    data: () => ({
        message: {
            name: "",
            description: ""
        },
        selectedClients: []
    }),
    validations: {
        message: {
            name: { required },
            description: { required }
        }
    },
    computed: {
        ...mapGetters(["clients"]),
        orderedClients() {
            return this.clients.sort((a, b) => a.name - b.name);
        }
    },
    methods: {
        async sendMessage() {
            if (this.$v.$invalid) return this.$v.$touch();

            const br = { ...broadcastMessagesRepository };

            const payload = {
                ...this.message,
                userId: this.user.id,
                clients: this.selectedClients
            };

            try {
                const {
                    data: { status, msg, message }
                } = await br.saveCompanyBroadcastMessage(payload);
                if (status) {
                    toastr.success(msg);
                    this.clearForm();
                }
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al enviar el mensaje [${err.message}]`
                );
            } finally {
            }
        },
        clearForm() {
            this.selectedClients = [];
            this.$v.$reset();
            this.message.name = "";
            this.message.description = "";
        }
    },
    created() {
        this.load("clients");
    },
    mounted() {}
};
</script>
